import { connect } from 'react-redux';
import { reduxForm, change, formValueSelector } from 'redux-form';

import { setValue } from '../../actions/sales_actions';
import {
  fetchInventories,
  fetchInventoriesByGroup,
  fetchInventoriesByCategory,
  fetchAllInventories,
  fetchDetailedInventories,
  selectInventory,
  resetCurrentInventory,
  fetchInventoriesByPeriod,
  setOriginPage,
  fetchNonZeroInventories
} from '../../actions/inventories_actions';
import { fetchGroups, fetchGroupCategories, resetGroupAndCategory, setGroupCategory, selectProduct } from '../../actions/products_actions';
import { fetchWarehouses, resetWarehouses } from '../../actions/warehouses_actions';


import Inventories from '../../components/Inventories/inventories'

let inventories = reduxForm({
    form: 'inventories',
    destroyOnUnmount: false,
})(Inventories);

const selector = formValueSelector('inventories');

function mapStateToProps(state) {
    const typeRadios = selector(state, 'typeRadios');
    const periodRadios = selector(state, 'periodRadios');
    const fromDate = selector(state, 'FromDate');
    const toDate = selector(state, 'ToDate');
    const DateRange = selector(state, 'DateRange');
    const warehouse = selector(state, 'Warehouse');

    return {
        typeRadios,
        periodRadios,
        fromDate,
        toDate,
        DateRange,
        warehouse,

        groups: state.products.groups,
        inventories: state.inventories.detailedInventories,
        isLoading: state.inventories.detailedInventoriesIsLoading,
        error: state.inventories.detailedInventoriesError,
        currentInventory: state.inventories.currentInventory,
        inventoriesByGroup: state.inventories.inventoriesByGroup,
        inventoriesByGroupIsLoading: state.inventories.inventoriesByGroupIsLoading,
        inventoriesByGroupError: state.inventories.inventoriesByGroupError,
        inventoriesByCategory: state.inventories.inventoriesByCategory,
        inventoriesByCategoryIsLoading: state.inventories.inventoriesByCategoryIsLoading,
        inventoriesByCategoryError: state.inventories.inventoriesByCategoryError,
        groupCategories: state.products.groupCategories,
        currentCategoryGroup: state.products.currentCategoryGroup,

        inventoriesByPeriod: state.inventories.inventoriesByPeriod,
        inventoriesByPeriodIsLoading: state.inventories.inventoriesByPeriodIsLoading,
        inventoriesByPeriodError: state.inventories.inventoriesByPeriodError,
        product: state.products.product,

        nonZeroInventories: state.inventories.nonZeroInventories,
        nonZeroInventoriesIsLoading: state.inventories.nonZeroInventoriesIsLoading,
        nonZeroInventoriesError: state.inventories.nonZeroInventoriesError,

        warehouseList: state.warehouses.all,
        warehouseListIsLoading: state.warehouses.isLoading,
        fetchWarehousesError: state.warehouses.fetchWarehousesError,
    };
}

export default connect(mapStateToProps, {
  fetchInventories, fetchInventoriesByGroup, fetchInventoriesByCategory, setGroupCategory, setOriginPage,
  fetchDetailedInventories, selectInventory, resetCurrentInventory, resetGroupAndCategory, selectProduct,
  fetchGroups, fetchGroupCategories, setValue, fetchInventoriesByPeriod, fetchAllInventories, fetchNonZeroInventories,
  fetchWarehouses,
  resetWarehouses,
})(inventories);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventories.jsx